import {
  IconHandshakeFilled,
  IconMessageQuestionFilled,
  IconProfileFilled,
  IconTourDoorFilled,
} from '@zillow/constellation-icons';
import { MESSAGE_TYPES } from './messageTypes';

/**
 * Base icon mapping for high-priority system messages (highPriorityWithLogo)
 */
const BASE_SYSTEM_MESSAGE_ICON_MAP = {
  // Applications
  [MESSAGE_TYPES.SYSTEM_MESSAGE.APPLICATIONS.APPLICATION_RECEIVED]: IconProfileFilled,

  // Leases
  [MESSAGE_TYPES.SYSTEM_MESSAGE.LEASES.LEASE_COUNTERSIGNING_COMPLETE]: IconHandshakeFilled,

  // Tours
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_CONFIRMED]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_INSTANT_BOOKED]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_REQUEST_QUICK]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_RESCHEDULED_CONFIRMED]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_RESCHEDULED_INSTANT]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_RESCHEDULED_REVIEW]: IconTourDoorFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_RESCHEDULED_BY_LANDLORD]: IconTourDoorFilled,
} as const;

/**
 * Renter-specific icon overrides
 */
const RENTER_ICON_OVERRIDES = {
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_REQUEST_QUICK]: IconMessageQuestionFilled,
  [MESSAGE_TYPES.SYSTEM_MESSAGE.TOURS.TOUR_RESCHEDULED_REVIEW]: IconMessageQuestionFilled,
} as const;

/**
 * Icon mapping for landlord-facing high-priority system messages
 */
export const LANDLORD_SYSTEM_MESSAGE_ICON_MAP = BASE_SYSTEM_MESSAGE_ICON_MAP;

/**
 * Icon mapping for renter-facing high-priority system messages
 */
export const RENTER_SYSTEM_MESSAGE_ICON_MAP = {
  ...BASE_SYSTEM_MESSAGE_ICON_MAP,
  ...RENTER_ICON_OVERRIDES,
} as const;

export type SystemMessageType = keyof typeof BASE_SYSTEM_MESSAGE_ICON_MAP;
